import React, { useEffect, useState } from "react";
import {
  Box,
  Center,
  Flex,
  Grid,
  Radio,
  Text,
  Spacer,
  Divider,
  Button,
  useDisclosure,
  useToast,
} from "@chakra-ui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import AuthModal from "./AuthModal";
import { useAuth } from "../context/authContext";
import axios from "axios";

const PaymentPlan = ({ selectedPlan, navBack }) => {
  const [duration, setDuration] = useState(0);
  const [paying, setPaying] = useState(false);
  const auth = useAuth();

  // selectedPlan
  useEffect(() => {
    let planDuration = selectedPlan.timeLength;
    switch (planDuration) {
      case "monthly":
        setDuration(1);
        break;
      case "quarterly":
        setDuration(4);
        break;
      case "yearly":
        setDuration(12);
        break;
      default:
        break;
    }
  }, [selectedPlan.timeLength]);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const finalRef = React.useRef();
  const toast = useToast();

  const initPayment = () => {
    if (!auth.user) {
      return onOpen();
    }

    let packageCredentials = {
      organizationId: auth.user.user._id,
      packageId: selectedPlan.packageId,
      durationId: selectedPlan._id,
    };

    setPaying(true);
    axios
      .post(
        `${process.env.REACT_APP_BASE_API}payments/organization/initialize`,
        packageCredentials
      )
      .then(
        (res) => {
          setPaying(false);
          let paystackCredentials = res.data.data;
          window.open(paystackCredentials.data.authorization_url, "_blank");
        },
        (err) => {
          setPaying(false);

          return toast({
            title: "Error",
            description: "Something went wrong, please try again",
            status: "error",
            duration: 9000,
            isClosable: true,
          });
        }
      );
  };

  return (
    <div>
      <Grid sx={{ minHeight: "100vh", width: "100%" }}>
        <Center width={"100%"} height={"100%"}>
          <Flex direction="column">
            <Box sx={{ cursor: "pointer" }}>
              <FontAwesomeIcon
                icon={faArrowLeft}
                color="#636A86"
                size="lg"
                onClick={() => navBack()}
              />
            </Box>
            <Box marginBottom="20px">
              <Flex justifyContent="center">
                <Box>
                  <Text
                    fontSize="20px"
                    fontWeight="bold"
                    weight="600"
                    color="#636A86"
                  >
                    Payment Plan
                  </Text>
                </Box>
              </Flex>
            </Box>
            <Box
              sx={{
                border: "1px solid #DAE0EA",
                borderRadius: "4px",
                width: "393px",
                height: "350px",
                textAlign: "center",
              }}
            >
              <Box>
                <Flex>
                  <Box p="5">
                    <Text
                      color="#5e97ce"
                      fontSize="20px"
                      fontWeight="bold"
                      weight="600"
                      sx={{ textTransform: "capitalize" }}
                    >
                      {selectedPlan.packageName}
                    </Text>
                  </Box>
                  <Spacer />
                  <Box p="5">
                    <Text
                      color="#5e97ce"
                      fontSize="20px"
                      fontWeight="bold"
                      weight="600"
                    >
                      ${selectedPlan.price}
                    </Text>
                    <Text
                      fontSize="16px"
                      fontWeight="bold"
                      weight="600"
                      marginRight="40px"
                      sx={{ textTransform: "uppercase" }}
                    >
                      for {duration} {duration > 1 ? "months" : "month"}
                    </Text>
                  </Box>
                </Flex>
                <Divider width="388px" border="2px solid gray" />
                <Center>
                  <Text
                    color="gray"
                    fontSize="18px"
                    fontWeight="semibold"
                    weight="600"
                    marginTop="20px"
                  >
                    Your payment is {selectedPlan.price} for
                  </Text>
                </Center>
                <Center>
                  <Text
                    color="gray"
                    fontSize="18px"
                    fontWeight="semibold"
                    weight="600"
                  >
                    {duration} {duration > 1 ? "months" : "month"} starting
                    Today
                  </Text>
                </Center>
              </Box>
              <Center>
                <Divider
                  width="300px"
                  marginTop="20px"
                  border="2px solid gray"
                />
              </Center>
              <Box>
                <Radio
                  marginTop="15px"
                  size="lg"
                  name="1"
                  colorScheme="blue"
                  defaultChecked
                >
                  <Text
                    color="gray"
                    fontSize="14px"
                    fontWeight="semibold"
                    weight="600"
                  >
                    I agree to the terms and Conditions
                  </Text>
                </Radio>
              </Box>
              <Box>
                <Button
                  border="2px solid #5e97ce"
                  backgroundColor="#fff"
                  color="#5e97ce"
                  textAlign="center"
                  fontSize="20px"
                  fontweight="bold"
                  weight="600"
                  borderRadius="50px"
                  marginTop="20px"
                  width="150px"
                  onClick={initPayment}
                  ref={finalRef}
                  isLoading={paying}
                >
                  Pay Now
                </Button>
              </Box>
            </Box>
          </Flex>

          <AuthModal finalRef={finalRef} isOpen={isOpen} onClose={onClose} />
        </Center>
      </Grid>
    </div>
  );
};

export default PaymentPlan;
